<template>
	<div id="app">
		<keep-alive ref="keepAlive">
			<router-view v-if="$route.meta.keepAlive"></router-view>
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive"></router-view>

		<download-banner v-if="!isInWebview" />
		<!--		<div-->
		<!--			v-if="isLg"-->
		<!--			style="user-select: none;pointer-events: none; position: fixed; left: 20px; top: 50vw; opacity: 0.8;font-size: 20px"-->
		<!--		>-->
		<!--			新版容器-->
		<!--		</div>-->
	</div>
</template>
<script>
//qa   https://m-second-hand-car-mall-qa.nio.com/module_10021/carhome?header=%7B%22backBtColor%22%3A%22black%22,%22headerBgColor%22%3A%22ffffff%22%7D&wv=do
//sit  https://m-second-hand-car-mall-sit.nio.com/module_10021/carhome?header=%7B%22backBtColor%22%3A%22black%22,%22headerBgColor%22%3A%22ffffff%22%7D&wv=do
//stg  https://m-second-hand-car-mall-stg.nio.com/module_10021/carhome?header=%7B%22backBtColor%22%3A%22black%22,%22headerBgColor%22%3A%22ffffff%22%7D&wv=do
//prod https://m-second-hand-car-mall.nio.com/module_10021/carhome?header=%7B%22backBtColor%22%3A%22black%22,%22headerBgColor%22%3A%22ffffff%22%7D&wv=do

import nativeHybrid from './util/nativeHybrid'
import util from '@/util/util'
import { bindRegisterEvents } from '@/hooks/useNetwork'

export default {
	name: 'app',
	created() {
		nativeHybrid.hideLoading()
	},
	data() {
		return {
			isLg: nativeHybrid.isCNLg(),
			isInWebview: util.isInWebview()
		}
	},
	components: {},
	mounted() {
		bindRegisterEvents()
	}
}
</script>
<style lang="scss">
@import './assets/base';
@font-face {
	font-family: 'Blue Sky Noto';
	src: url('https://static.nio.com/fx-static/configh5/clbose0se0003078h68q3dgcs/BlueSkyNotoRegular-subset.woff')
			format('woff'),
		url('https://static.nio.com/fx-static/configh5/clbosdvet0002078hffa1d51e/BlueSkyNotoRegular-subset.ttf')
			format('truetype');
}

@font-face {
	font-family: 'Blue Sky Noto-Bold';

	src: url('https://static.nio.com/fx-static/configh5/clc4rrp1y0001078p6czh7c6n/BlueSkyNotoBold-subset.woff')
			format('woff'),
		url('https://static.nio.com/fx-static/configh5/clc4rree70000078p1spv19zo/BlueSkyNotoBold-subset.ttf')
			format('truetype');
}

/* 初始化 banner 选择样式 */
.van-swipe__indicator {
	width: 5px;
	height: 5px;
	background-color: #fff;
	opacity: 0.8;
	border-radius: 3px;
	// transition: width 1s;
}
.van-swipe__indicators {
	bottom: 15px;
}
.van-swipe__indicator--active {
	width: 20px;
	background-color: #00bcbc;
	opacity: 1;
}
.van-swipe__indicator:not(:last-child) {
	margin-right: 10px;
}

.nio-sheet {
	padding: 0 !important;
}
</style>
